import { MigrationsMap } from '../types'

// No shape changes yet — this file exists so a future `BulkInquiryState` change has somewhere to
// migrate from, following the same pattern as the root `src/redux/migrations.ts`. Whenever the
// persisted shape changes: bump `version` in `bulkInquiryPersistConfig` (`src/redux/reducer.ts`) and
// add a `'<oldVersion>': state => ...` entry here.
const bulkInquiryMigrations: MigrationsMap = {}

export default bulkInquiryMigrations
